// Week 33 Word Match Pairs (10 Pairs)
export default [
  { id: 1, word: "corridor", definition_en: "long passage in a building", definition_vi: "hành lang" },
  { id: 2, word: "slipped", definition_en: "slid accidentally on wet floor", definition_vi: "trượt chân" },
  { id: 3, word: "nurse", definition_en: "school medical carer", definition_vi: "y tá" },
  { id: 4, word: "bandage", definition_en: "strip of cloth for cuts", definition_vi: "băng cá nhân" },
  { id: 5, word: "relieved", definition_en: "feeling happy after worry", definition_vi: "nhẹ nhõm" },
  { id: 6, word: "mistake", definition_en: "incorrect action", definition_vi: "lỗi lầm" },
  { id: 7, word: "accident", definition_en: "unexpected incident", definition_vi: "tai nạn" },
  { id: 8, word: "fix", definition_en: "to repair or mend", definition_vi: "sửa chữa" },
  { id: 9, word: "careful", definition_en: "avoiding danger", definition_vi: "cẩn thận" },
  { id: 10, word: "clumsy", definition_en: "moving without balance", definition_vi: "vụng về" }
];
